<span *ngIf="header" class="field-header">{{header}}</span> 

<mat-form-field 
class="form-control" 
style="width: 100%" 
[ngClass]="header ? 'mt-2' : ''"
[appearance]="appearance">
  <mat-label>{{ label }}</mat-label>
  <input
    matInput
    placeholder="Sample"
    [placeholder]="label ? label : ''"
    [formControl]="controlName"
    (blur)="onBlurEvent($event)"
    [readonly]="readonly"
  />
  <mat-icon *ngIf="hasError()" matSuffix color="warn">info</mat-icon>
  <!-- <mat-icon *ngIf="!validators.length"  color="primary" matSuffix>{{icon}}</mat-icon> -->
  <mat-icon *ngIf="(!hasError() && !isValid()) || !validators.length"  color="primary" matSuffix>{{icon}}</mat-icon>
  <mat-icon *ngIf="isValid() && validators.length" matSuffix class="icon-success">check_circle</mat-icon>
  <mat-error *ngIf="hasError()">{{ getErrorMessage() }}</mat-error>
  <img *ngIf="iconUrl && (!validators.length || (!hasError() && !isValid()))" [src]="iconUrl" alt="icon" matSuffix class="mx-3"/>
</mat-form-field>
